import type { Context } from '..';
import type { ChangeRoutePayload } from '../machines/router';

export const renewTokenFailed = ({ state }: Context, error: Error) => {
  state.auth.send('AUTHENTICATION_ERROR', error.message);
};

export const setFeatureToggles = (
  ctx: Context,
  toggles: NonNullable<Context['state']['featureToggles']>
) => {
  ctx.state.featureToggles = {
    isEsriWebMapEnabled: toggles.isEsriWebMapEnabled,
    isSharingExecutionEnabled: toggles.isSharingExecutionEnabled,
    isSavingCalculationSetExecutionReportEnabled:
      toggles.isSavingCalculationSetExecutionReportEnabled,
    isShowingGridElementTitleEnabled: toggles.isShowingGridElementTitleEnabled,
    isShowingApplicationVersionEnabled:
      toggles.isShowingApplicationVersionEnabled,
    isContainmentExecutionTimeCalculatedEnabled:
      toggles.isContainmentExecutionTimeCalculatedEnabled,
    isNewAuthVersionEnabled: toggles.isNewAuthVersionEnabled,
    isProtectiveDevicesEnabled: toggles.isProtectiveDevicesEnabled,
    isWebmapBackgroundMapEnabled: toggles.isWebmapBackgroundMapEnabled,
    isNewPropertiesForAcLineSegmentEnabled:
      toggles.isNewPropertiesForAcLineSegmentEnabled,
    isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled:
      toggles.isArcGisJsSDKWebMapForBrowsingCalculationResultsEnabled,
    shouldUseArcGisTokenRefreshing: toggles.shouldUseArcGisTokenRefreshing,
    shouldUseInitiatingObjectHighlighting: toggles.shouldUseInitiatingObjectHighlighting,
    evaluationRulesTechnicalBoundariesAdjustment: toggles.evaluationRulesTechnicalBoundariesAdjustment
  };
  ctx.state.auth.send('FEATURE_TOGGLES_READY');
};

export const resetFeatureToggles = (ctx: Context) => {
  ctx.state.featureToggles = undefined;
  ctx.state.auth.send('FEATURE_TOGGLES_RESET');
};

export const setConfigApiAccess = (
  ctx: Context,
  hasAccess: boolean
) => {
  ctx.state.hasConfigApiAccess = hasAccess;
};

export const setRoute = ({ state }: Context, payload: ChangeRoutePayload) => {
  state.router.send('CHANGE_ROUTE', payload);
};

export const notFoundRouted = ({ state }: Context) => {
  state.router.send('NOT_FOUND_ROUTED');
};

export const accessTokenExpired = (context: Context) => {
  context.state.auth.send('ACCESS_TOKEN_EXPIRED');
}

export const restartApp = async (context: Context) => {
  await context.effects.auth.refreshToken();
  window.location.reload();
}
